import {DebuggingComponent} from '@fantasmagames/slot/src/common/debugging/DebuggingComponent';
import {CurrencyFormatter} from '@fantasmagames/core/src/utils/CurrencyFormatter';

export class CheatDebuggingComponent extends DebuggingComponent {
	public init(): void {
		super.init();

		this.addWindowFunction('SwitchCurrency', this.switchCurrency.bind(this));
	}

	protected switchCurrency(currencyISO: string): void {
		const currencyData = (this.view.currencyFormatter as any).parseCurrencyFormatting(
			currencyISO,
			CurrencyFormatter.CurrenciesDisplayFormat[currencyISO],
		);
		(this.view.currencyFormatter as any).setCurrencyData(currencyData);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/cheat/debuggingComponent/CheatDebuggingComponent.ts